var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowCircle = function SvgArrowCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 38 38"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#204969",
    d: "M3.407 19.07c0 8.648 7.047 15.694 15.695 15.694s15.694-7.046 15.694-15.694S27.749 3.376 19.102 3.376 3.407 10.423 3.407 19.07m14.549-6.372 5.54 5.54c.235.236.345.534.345.832 0 .299-.11.597-.345.832l-5.54 5.54a1.184 1.184 0 0 1-1.664 0 1.184 1.184 0 0 1 0-1.663L21 19.07l-4.708-4.708a1.184 1.184 0 0 1 0-1.664 1.184 1.184 0 0 1 1.664 0"
  })));
};
export default SvgArrowCircle;